module.exports = __webpack_public_path__ + "a7deffc4871115e73a8d4947fe61f537.MP3";